import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    const filteredList = items.filter((it) => {
      return it.name.toLowerCase().includes(searchText) || it.phone.toLowerCase().includes(searchText);
    });
    if (!filteredList.length) {
      return [-1];
    } else {
      return filteredList;
    }
  }
}
